'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Warning.tsx
var SvgWarning = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.363 3.549 1.35 16.963l-.028.047c-.198.33-.396.663-.534.951-.14.294-.337.776-.275 1.353a2.438 2.438 0 0 0 1.023 1.732c.46.324.962.397 1.288.425.322.03.713.03 1.11.029h16.133c.396 0 .787 0 1.109-.029.326-.028.828-.101 1.288-.425.567-.4.947-1.027 1.023-1.732.062-.577-.135-1.059-.276-1.353-.137-.288-.336-.62-.533-.95l-.028-.048-8.014-13.414-.028-.047c-.197-.33-.395-.66-.583-.919-.196-.267-.518-.656-1.037-.88a2.503 2.503 0 0 0-1.979 0c-.518.224-.84.613-1.036.88-.189.259-.386.59-.583.919l-.028.047ZM2.637 17.732l8.014-13.414c.443-.741.664-1.112.953-1.237.252-.108.54-.108.792 0 .289.125.51.496.953 1.237l8.014 13.414c.444.744.667 1.116.634 1.422a.939.939 0 0 1-.396.666c-.256.18-.7.18-1.587.18H3.986c-.887 0-1.33 0-1.587-.18a.939.939 0 0 1-.396-.666c-.033-.306.19-.678.634-1.422ZM11.25 9a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-1.5 0V9ZM11 17a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z" }));
var Warning_default = SvgWarning;

module.exports = Warning_default;
